import React from 'react'

import { H1 } from '@mxenabled/mxui'

import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded'
import ListIcon from '@mui/icons-material/List'
import { Box, Button, Tab, Tabs, ToggleButton, ToggleButtonGroup } from '@mui/material'

const copy = {
  active_tab: 'Active',
  all_tab: 'All',
  create_insight_button: 'Create Insight',
  custom_insights_title: 'Custom Insights',
  disabled_tab: 'Disabled',
  pending_tab: 'Pending',
}

enum Views {
  grid = 'GRID',
  list = 'LIST',
}

export const Page = () => {
  const [layoutView, setLayoutView] = React.useState(Views.grid)
  const [activeTab, setActiveTab] = React.useState(0)

  const changeLayout = (_: React.MouseEvent, newLayout: Views) => {
    if (newLayout !== null) {
      setLayoutView(newLayout)
    }
  }

  const changeTab = (_: React.SyntheticEvent, newTab: number) => {
    setActiveTab(newTab)
  }

  return (
    <>
      <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', mb: 12 }}>
        <H1>{copy.custom_insights_title}</H1>
        <Box sx={{ display: 'flex', gap: 32, justifyContent: 'center' }}>
          <ToggleButtonGroup exclusive={true} onChange={changeLayout} value={layoutView}>
            <ToggleButton size="small" value={Views.grid}>
              <GridViewRoundedIcon color={layoutView === Views.grid ? 'primary' : 'secondary'} />
            </ToggleButton>
            <ToggleButton size="small" value={Views.list}>
              <ListIcon color={layoutView === Views.list ? 'primary' : 'secondary'} />
            </ToggleButton>
          </ToggleButtonGroup>
          {/* TODO hook up button */}
          <Button onClick={() => {}} variant="contained">
            {copy.create_insight_button}
          </Button>
        </Box>
      </Box>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs onChange={changeTab} value={activeTab}>
            <Tab label={copy.all_tab} />
            <Tab label={copy.active_tab} />
            <Tab label={copy.pending_tab} />
            <Tab label={copy.disabled_tab} />
          </Tabs>
        </Box>
      </Box>
    </>
  )
}
